import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LocationInfo } from '../../../geolocation-data/models/location-info.model';
import { GeolocationDataService } from '../../../geolocation-data/geolocation-data.service';
import { LocationSuggestionResult } from '../../../geolocation-data/models/location-suggestion-result.model';
import { LocationSuggestions } from '../../../geolocation-data/models/location-suggestions.model';
import { IAutoCompleteOptions } from '../../../shared/directives/auto-complete/auto-complete.interface';
import { locationSuggestionTmpl } from './auto-complete.tmpl';
import { map } from 'rxjs/operators';

@Injectable()
export class AddressFieldBuilder {
  constructor(private _geolocationDataService: GeolocationDataService) {}

  buildAutoCompleteOptions(
    locationInfo: LocationInfo,
    accountCountry: string
  ): IAutoCompleteOptions {
    return {
      async: true,
      asyncCallback: (
        query: string
      ): Observable<LocationSuggestionResult[]> => {
        return query && query.length >= 3
          ? this._geolocationDataService
              .getLocationSuggestions(query, locationInfo, accountCountry)
              .pipe(
                map((locationSuggestions: LocationSuggestions) =>
                  locationSuggestions.results.toArray()
                )
              )
          : of([]);
      },
      itemTemplate: locationSuggestionTmpl,
      highlighter: false,
      highlightCompleteWords: false,
      limit: 5,
      emitEventOnSet: true,
      setFn: (value: LocationSuggestionResult) => value.text,
      autoSelectFirstResult: false,
      supportMultilineInput: true,
    };
  }
}
